module.exports = __webpack_public_path__ + "img/map-google.12d8cd95.png";